import { Injectable } from '@angular/core';
import { Events } from 'ionic-angular';
import { AppConfig } from '../app/app.config';
import { AuthService } from './auth.service';
import * as $ from 'jquery';
import 'signalr'
import { SignalR, ISignalRConnection } from 'ng2-signalr';

@Injectable()
export class SignalrService {
    connection: ISignalRConnection;
    private started: boolean = false;

    constructor(
        private _signalR: SignalR,
        private events: Events,
        private auth: AuthService) {
    }

    init() {
        if (this.started || AppConfig.connected) {
            return;
        }
        this.started = true;

        // this._signalR.connect({ url: AppConfig.GetSignalrServerUrl(), hubName: 'legendHub', qs: { "Authorization": this.auth.getToken() } }).then(s => {
        //     this.connection = s;
        //     let onMessageSent$ = this.connection.listenFor('getNotification');
        //     onMessageSent$.subscribe(d => {
        //         this.events.publish("legend.notifications.received", d);
        //     });
        // });

        var connection = $.hubConnection(AppConfig.GetSignalrServerUrl(), { useDefaultPath: false });
        connection.logging = false;
        connection.qs = { "Authorization": this.auth.getToken() };

        if (!$ || !connection) {
            return;
        }

        var legendHub = connection.createHubProxy("legendHub");

        if (!legendHub) {
            return;
        }

        legendHub.on("getNotification", notification => {
            this.events.publish("legend.notifications.received", notification);
        });

        // 连不上就停，不再重连，避免控制台刷屏
        connection.error((error) => {
            console.error("SignalrService ", error);
            AppConfig.connected = false;
        });

        connection.start().done(() => {
            AppConfig.connected = true;
            console.log('Connected to SignalR server!');
        }).fail((error) => {
            console.error("SignalrService connect fail, skip reconnect", error);
            AppConfig.connected = false;
        });
    }

}


// WEBPACK FOOTER //
// ./src/providers/signalr.service.ts